import { Button, Row } from "antd";
import React, { FC, useEffect, useState } from "react";
import { CustomSelect } from "../../../ui";
import { DashboardCard } from "../ui/DashboardCard";
import { OverviewChart } from "./OverviewChart";
import { OverviewEmptyData } from "./OverviewEmptyData";
import "./index.less";
import { SvgIcon } from "src/shared/icons";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { outreachCampaignSelector } from "src/store/outreach-campaigns";
import { Loader } from "src/components/layout";
import { getEmailGraphAnalytics } from "src/store/outreach-campaigns/asyncRequests";
import { AppDispatch } from "src/store";
import { fullUserSelector, userSelector } from "src/store/user";

interface OverviewCardProps {
  // data?: any;
}

export const periodOptions = [
  {
    label: "Last 7 days",
    value: "Last 7 days",
  },
  {
    label: "Last Month",
    value: "Last Month",
  },
];

const overviewItemsOptions = [
  {
    label: "Emails",
    value: "Emails",
  },
  {
    label: "Phone and SMS",
    value: "Phone and SMS",
  },
];

export const OverviewCard: FC<OverviewCardProps> = () => {
  // const [periodOfTime, setPeriodOfTime] = useState("Emails");
  const [periodOfTime, setPeriodOfTime] = useState("Last 7 days");
  const { emailAnalyticsGraphData, loadingGraphAnalytics } = useSelector(outreachCampaignSelector);
  const dispatch = useDispatch<AppDispatch>();
  const getAnalytics = (timeframe?: string) => {
    const tz = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
    dispatch(getEmailGraphAnalytics({ timeframe: timeframe || periodOfTime, tz }));
  };
  let { user } = useSelector(fullUserSelector);

  const handleChangeTimeframe = (val) => {
    // console.log(val, "VALasvsdav");
    setPeriodOfTime(val);
    getAnalytics(val);
  };

  // const handleChange = (value: string) => {
  //   setSelectedChartType(value);
  // };
  // console.log(emailAnalyticsGraphData, "emailAnalyticsGraphData");
  const headerRightContent = (
    <Row wrap={false} style={{ gap: 18 }}>
      {/* <CustomSelect
        customClassName={"dashboard-select"}
        options={overviewItemsOptions}
        onChange={handleChange}
        defaultValue={"Emails"}
        popupClassName={"dashboard-select-dropdown"}
        style={{ width: 138, height: 26 }}
      /> */}
      <Button className="link" onClick={() => !loadingGraphAnalytics && getAnalytics()}>
        {loadingGraphAnalytics ? <Loader size={"small"} /> : <SvgIcon type={"refresh"} width={12} height={12} />}
        Refresh
      </Button>
      <CustomSelect
        options={periodOptions}
        value={periodOfTime}
        popupClassName={"dashboard-select-dropdown"}
        style={{ width: 130, height: 26 }}
        isSearchSelect={false}
        onSelect={handleChangeTimeframe}
      />
    </Row>
  );

  // fake random data
  const [analyticsData, setAnalyticsData] = useState([]);

  useEffect(() => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const fullData = [];

    for (let i = 0; i < 30; i++) {
      const m = moment()
        .tz(timezone)
        .subtract(29 - i, "days");
      const date = m.format("DD MMM");
      const isWeekend = [6, 0].includes(m.day());

      const aiSent = isWeekend ? 0 : Math.floor(Math.random() * 41) + 30;
      const templSent = isWeekend ? 0 : Math.floor(Math.random() * 41) + 30;
      const totalSent = aiSent + templSent;
      const opened = isWeekend ? 0 : Math.floor(Math.random() * (Math.floor(totalSent * 0.6) - Math.ceil(totalSent * 0.3) + 1)) + Math.ceil(totalSent * 0.3);
      const clicked = isWeekend ? 0 : Math.floor(Math.random() * (Math.floor(opened * 0.3) - Math.ceil(opened * 0.1) + 1)) + Math.ceil(opened * 0.2);
      const replied = isWeekend ? 0 : Math.floor(Math.random() * (Math.floor(clicked * 0.2) - Math.ceil(clicked * 0.05) + 1)) + Math.ceil(clicked * 0.25);
      const forwarded = isWeekend ? 0 : Math.floor(Math.random() * (Math.floor(opened * 0.1) + 1));
      const booked = isWeekend ? 0 : Math.floor(Math.random() * (Math.floor(replied * 0.3) - Math.ceil(replied * 0.1) + 1)) + Math.ceil(replied * 0.1);

      fullData.push({ date, type: "Ai Personalized Em. Sent", value: aiSent });
      fullData.push({ date, type: "Templated Em. Sent", value: templSent });
      fullData.push({ date, type: "Opened", value: opened });
      fullData.push({ date, type: "Clicked", value: clicked });
      fullData.push({ date, type: "Forwarded", value: forwarded });
      fullData.push({ date, type: "Replied", value: replied });
      fullData.push({ date, type: "Booked", value: booked });
    }

    console.log("Full 30-day data:", fullData);
    setAnalyticsData(fullData);
  }, []);

  // determine how many days to show
  const days = periodOfTime === "Last 7 days" ? 7 : 30;
  const metricsPerDay = 7;
  const chartData = analyticsData.slice(-days * metricsPerDay);

  const isTest = user?.is_testing_mode_now;
  // const days = periodOfTime === "Last 7 days" ? 7 : 30;
  // const metricsPerDay = 7;
  // const chartData = analyticsData.slice(-days * metricsPerDay);

  return (
    <DashboardCard
      customClassName={"overview-card-wrapper"}
      title={"Email Analytics Overview"}
      headerRightContent={headerRightContent}
      // style={{ width: "120px" }}
    >
      {!!isTest || !!emailAnalyticsGraphData?.length ? <OverviewChart data={isTest ? chartData : emailAnalyticsGraphData} /> : <OverviewEmptyData />}
    </DashboardCard>
  );
};
